module.exports = __webpack_public_path__ + "static/trophy-b057b5729e09ad400aac8587e2cc2221.png";